module.exports = __webpack_public_path__ + "static/img/7.8bc12c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Personas/7.png
// module id = bvtJ
// module chunks = 0